import React from 'react'
import classNames from 'classnames'
import './Message.scss'

class Message extends React.Component {
  matchedItem() {
    return this.props.data.children.filter(d => d.matched)
  }
  render() {
    return (
      <div className={classNames({'message': true, '--show': !this.props.data})}>
        該当の商品がありません。<br />条件を変更してください。
      </div>
    )
  }
}

export default Message
